export default __webpack_public_path__ + "static/media/logo-horizontal.1fe3daf8.png";